<bivariate-map>
  <div class="maple-bivariate-map__svg-wrapper" id="maple-svg-container" />

  <script>
    import { CONTROL, EVENTS } from '~/events.js'
    import renderMap from './render.js'
    import { hilight, unhilight } from './hilight.js'

    export default {
      state: {
        hilighted: null
      },
      onMounted() {
        this.selection = renderMap('#maple-svg-container')
        this.attachEvents()
      },
      attachEvents() {
        CONTROL.on(EVENTS.hilight, id => {
          this.update({
            hilighted: hilight(this.selection, id, this.state.hilighted)
          })
        })
        CONTROL.on(EVENTS.unhilight, () => unhilight(this.state.hilighted))
      }
    }
  </script>
</bivariate-map>
